/**
 * @generated SignedSource<<3191666a9caa05c54bc7588581097781>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CategoryInfo_info$data = {
  readonly entries: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"CategoryInfoEntry_entry">;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "CategoryInfo_info";
};
export type CategoryInfo_info$key = {
  readonly " $data"?: CategoryInfo_info$data;
  readonly " $fragmentSpreads": FragmentRefs<"CategoryInfo_info">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CategoryInfo_info",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CategoryInfoEntry",
      "kind": "LinkedField",
      "name": "entries",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "CategoryInfoEntry_entry"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "CategoryInfo",
  "abstractKey": null
};

(node as any).hash = "ae95bd959ac02812aca4c47c728aaf78";

export default node;
